import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useEffect, useState } from 'react';
import { Sidebar, Menu, MenuItem } from 'react-pro-sidebar';
import { faArrowLeft, faChartSimple, faListUl, faFileLines, faSchool,faRightFromBracket, faCalendar} from '@fortawesome/free-solid-svg-icons';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import authService from '../../services/auth/auth.service';
import './MySidebar.css';


const MySidebar = () => {
    const [collapsed, setCollapsed] = useState(true);
    const [visible, setVisible] = useState(false);
    const nav = useNavigate();
    const handleToggleSidebar = () => {
        setCollapsed(!collapsed);
    };
    const location = useLocation();

    
    useEffect(() => {
        if (location.pathname.includes('admin')) {
            setVisible(true);
        } else {
            setVisible(false);
        }
    }, [location]);
    const logout = async () => {
        authService.logout().then(() => nav('/admin/logout'));
    }
    return visible ? (
        <Sidebar className='side' collapsed={collapsed} style={{ height: '100vh' }}>
            <Menu>
                <MenuItem onClick={handleToggleSidebar} className={collapsed ? 'colap' : ''}><FontAwesomeIcon icon={faArrowLeft} /></MenuItem>
                <MenuItem className='title' disabled={true}>
                    {
                        collapsed ? <img src="/emprendedores/UABClogos/logo_icono.png" alt="" className='logo' /> : 'Panel de Control'
                    }
                </MenuItem>
                <MenuItem className='item' icon={<FontAwesomeIcon icon={faChartSimple}/>} component={<Link to='/admin/forms/projects/statistics'/>}>Estadísticas</MenuItem>
                <MenuItem icon={<FontAwesomeIcon icon={faListUl} />} component={<Link to='/admin/forms/projects' />}>Registro de Proyectos</MenuItem>
                <MenuItem icon={<FontAwesomeIcon icon={faSchool} />} component={<Link to='/admin/education-programs' />}>Programas Educativos</MenuItem>
                <MenuItem icon={<FontAwesomeIcon icon={faCalendar} />} component={<Link to='/admin/periods' />}>Periodos</MenuItem>
                {/*<MenuItem icon={<FontAwesomeIcon icon={faFileLines} />} >Herramientas del Formulario</MenuItem>*/}
                <MenuItem icon={<FontAwesomeIcon icon={faRightFromBracket} />} onClick={logout}>Cerrar sesion</MenuItem>
            </Menu>
        </Sidebar>
    ) : <></>;
};

export default MySidebar;
